import { useEffect } from "react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const sections = [
  {
    title: "Informational Purposes Only",
    text: "This website is provided for informational purposes only. Nothing on this website constitutes an offer to sell securities, an investment recommendation, a guarantee of profit, a guarantee of development approval, a guarantee of land value, or a binding partnership agreement.",
  },
  {
    title: "Invest With Us",
    text: "The phrase \"Invest With Us\" refers to the possibility of landowners contributing property to a structured real-estate development arrangement. This website does not publicly solicit cash investments and does not offer securities.",
  },
  {
    title: "No Guarantees",
    text: "Stelcore Development does not guarantee development approval, increased land value, profit, investment returns, lot counts or specific timelines. Any potential land-development arrangement is subject to due diligence, development feasibility, financing, legal documentation, tax considerations, professional advice and agreement between all parties.",
  },
  {
    title: "Project Information",
    text: "The projects on this website present information drawn from professional plans of survey and related documentation. Survey imagery is shown for presentation purposes; the original deposited plans govern for legal interpretation.",
  },
  {
    title: "Professional Advice",
    text: "Nothing on this website constitutes legal, tax, planning or financial advice. Landowners considering any development arrangement should obtain independent professional advice.",
  },
];

const LegalDisclaimer = () => {
  useEffect(() => {
    document.title = "Legal Disclaimer | Stelcore Development";
  }, []);

  return (
    <div data-testid="disclaimer-page">
      <section className="border-b border-ink/10">
        <div className="container-x py-16 md:py-24">
          <Reveal>
            <SectionLabel>Legal</SectionLabel>
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-bold uppercase mt-6">Legal Disclaimer</h1>
          </Reveal>
        </div>
      </section>
      <section>
        <div className="container-x py-16 md:py-20 max-w-3xl">
          {sections.map((s) => (
            <Reveal key={s.title}>
              <div className="border-b border-ink/10 py-8">
                <h2 className="text-lg font-semibold uppercase tracking-tight mb-4">{s.title}</h2>
                <p className="text-sm text-graphite leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
          <p className="text-xs text-graphite mt-10">© {new Date().getFullYear()} Stelcore Development All rights reserved.</p>
        </div>
      </section>
    </div>
  );
};

export default LegalDisclaimer;
